const recordForms = { one: 'запись', few: 'записи', many: 'записей', other: 'записей', zero: 'записей', two: 'записи' };
const recordPlural = new Intl.PluralRules('ru-RU');

export function historyCount(count: number): string {
  return `${count} ${recordForms[recordPlural.select(count)]}`;
}
